var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-page',[_c('section-page',{attrs:{"title":"Communication Log","full-height":""},scopedSlots:_vm._u([{key:"right",fn:function(){return [_c('comms-filters')]},proxy:true}])},[_vm._v(" "),_c('comms-list')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }